import React, { useEffect, useState } from 'react';
import { gameApi, SpecialCard, UserLanguage } from '../api';
import { Card } from './Card';

const relatedCards: Record<string, string> = {
  Bless: 'Bless',
  'Call the Azure Flame': 'Azure Flame',
  'Summon the Beast Within': 'Inner Beast',
  'Open the Third Eye': 'Third Eye',
};

const catalogs = new Map<UserLanguage, Promise<SpecialCard[]>>();
export const clearSpellSpecialCardCache = () => catalogs.clear();

function loadCards(language: UserLanguage): Promise<SpecialCard[]> {
  let request = catalogs.get(language);
  if (!request) {
    request = gameApi.getWikiDeck('Special', language).then(response => response.cards as SpecialCard[]);
    catalogs.set(language, request);
    const current = request;
    request.catch(() => { if (catalogs.get(language) === current) catalogs.delete(language); });
  }
  return request;
}

function signedInLanguage(): UserLanguage {
  try { return localStorage.getItem('boardgame_auth_language') === 'Ru' ? 'Ru' : 'En'; }
  catch { return 'En'; }
}

export function SpellRelatedSpecialCard({ spellName }: { spellName: string }) {
  const name = Object.prototype.hasOwnProperty.call(relatedCards, spellName) ? relatedCards[spellName] : undefined;
  const language = signedInLanguage();
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState<{ key: string; card?: SpecialCard; error?: boolean }>();
  const key = JSON.stringify([name, language, attempt]);
  useEffect(() => {
    if (!name) return;
    let active = true;
    loadCards(language).then(cards => {
      const card = cards.find(candidate => candidate.name === name);
      if (active) setResult({ key, card, error: !card });
    }, () => { if (active) setResult({ key, error: true }); });
    return () => { active = false; };
  }, [name, language, key]);
  if (!name) return null;
  const current = result?.key === key ? result : undefined;
  return <section className="spell-related-special" aria-label="Related Special card">
    <h3>Related Special card</h3>
    {current?.card ? <Card card={{ kind: 'special', item: current.card }} />
      : current?.error ? <p role="alert">Could not load {name}. <button type="button" onClick={() => {
        catalogs.delete(language);
        setAttempt(value => value + 1);
      }}>Retry</button></p>
        : <p role="status">Loading {name}…</p>}
  </section>;
}
